import type { IOption, IPhoneNumber } from "@/interfaces";

const getPriceOptions = () => {
  if (import.meta.env.VITE_IOS === "true") {
    return [{ key: "IQD", value: "دینار", flag: "IQ" }];
  }

  return import.meta.env.VITE_LANGUAGE === "fa"
    ? [{ key: "IRR", value: "ریال", flag: "IR" }]
    : [{ key: "IQD", value: "دینار", flag: "IQ" }];
};

export const PRICE_CURRENCY_OPTIONS: IOption[] = getPriceOptions();

const getPhoneOptions = () => {
  if (import.meta.env.VITE_IOS === "true") {
    return [
      { key: "+964", value: "+964", flag: "IQ" },
      { key: "+966", value: "+966", flag: "SA" },
      { key: "+962", value: "+962", flag: "JO" },
      { key: "+90", value: "+90", flag: "TR" },
      { key: "+971", value: "+971", flag: "AE" },
    ];
  }

  return import.meta.env.VITE_LANGUAGE === "fa"
    ? [
        { key: "+98", value: "+98", flag: "IR" },
        { key: "+964", value: "+964", flag: "IQ" },
        { key: "+966", value: "+966", flag: "SA" },
        { key: "+962", value: "+962", flag: "JO" },
        { key: "+90", value: "+90", flag: "TR" },
        { key: "+971", value: "+971", flag: "AE" },
      ]
    : [
        { key: "+964", value: "+964", flag: "IQ" },
        { key: "+966", value: "+966", flag: "SA" },
        { key: "+962", value: "+962", flag: "JO" },
        { key: "+90", value: "+90", flag: "TR" },
        { key: "+971", value: "+971", flag: "AE" },
        { key: "+98", value: "+98", flag: "IR" },
      ];
};

export const PHONE_CODE_OPTIONS: IOption<string>[] = getPhoneOptions();

export const DEFAULT_CODE = PHONE_CODE_OPTIONS?.[0]?.key || "+98";
export const EmptyPhoneNumber: IPhoneNumber = {
  code: DEFAULT_CODE,
  number: "",
};
